import React from 'react';
import DatasetAdminPanelContainer from '../components/DatasetAdminPanelContainer';
import DatasetAdminPanelHeader from './DatasetAdminPanelHeader';
import DatasetAdminGrid from '../components/DatasetAdminGrid';
import selectors from '../hooks/selectors';
import fetch from '../../metrics/hooks/fetch';

const DatasetAdminPanelFull = ({
  category,
  code,
  onChange,
  url,
}) => {
  const state = selectors.useDatasetSettings({ category, code });
  fetch.useFetchDatasetMetrics({ category, code }, state.metricsReadStatus);

  return (
    <DatasetAdminPanelContainer
      canRead={state.canRead}
      category={category}
      code={code}
      exists={state.exists}
      readErrors={state.readErrors}
      readStatus={state.readStatus}
    >
      <div className="aridhia-dataset-admin-panel-full">
        <DatasetAdminGrid
          category={category}
          code={code}
          name={state.name}
          panels={state.panels}
          saveErrors={state.saveErrors}
          datasourceSupportsCohort={state.datasourceSupportsCohort}
        >
          <DatasetAdminPanelHeader code={code} category={category} onChange={onChange} url={url} />
        </DatasetAdminGrid>
      </div>
    </DatasetAdminPanelContainer>
  );
};

export default DatasetAdminPanelFull;
